import React, { InputHTMLAttributes } from "react";
import {
  FieldError,
  FieldErrorsImpl,
  Merge,
  UseFormRegister,
} from "react-hook-form";
import FormError from "./FormError";
import { useHookFormMask } from "use-mask-input";

interface FormInputType extends InputHTMLAttributes<any> {
  hint?: string;
  label?: string;
  mask?: string;
  theme?: string;
  placeholder?: string;
  register: UseFormRegister<any>;
  error: FieldError | Merge<FieldError, FieldErrorsImpl<any>> | undefined;
}

export default function FormInput({
  label,
  name,
  // hint,
  register,
  error,
  mask,
  onBlur,
  ...props
}: FormInputType): React.ReactElement {
  let registerProps;
  if (mask) {
    const registerWithMask = useHookFormMask(register);
    registerProps = registerWithMask(name ?? "", mask, {
      showMaskOnHover: false,
      onBlur: onBlur,
    });
  } else {
    registerProps = register(name ?? "", {
      onBlur: onBlur,
    });
  }

  return (
    <div>
      <label>
        <div className="text-[16px]/[24px] font-semibold lg:text-[18px]/[24px]">
          {label}
        </div>
        <div>
          <input
            className="w-full border-b-2 border-[#DCDCE8] py-3 text-[20px]/[26px] font-medium outline-0 autofill:shadow-[inset_0_0_0_1000px_#fff] lg:text-[24px]/[32px]"
            {...props}
            {...registerProps}
          />
          {/*<FormHint hint={hint} />*/}
        </div>
      </label>
      <FormError error={error} />
    </div>
  );
}
